<template>
  <div
    class="ProductItem"
    style="visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0)"
    v-if="product.id"
  >
    <div class="ProductItem__Wrapper">
      <a :href="product.url" class="ProductItem__ImageWrapper"
        ><div class="AspectRatio">
          <img
            v-for="(image, idx) in product.images"
            :key="idx"
            class="ProductItem__Image Image--lazyLoad Image--fadeIn"
            :src="image.src"
            :alt="image.alt"
          />
        </div>
      </a>
      <div class="ProductItem__LabelList">
        <div v-if="product.sold_out === 'present'" class="label sold-out">
          <p class="label__text">{{ store_availability.general.sold_out }}</p>
        </div>
        <div
          v-if="product.sold_out !== 'present' && product.discount"
          class="label discount"
        >
          <p class="label__text">Spar {{ product.discount }} %</p>
        </div>
        <div v-else-if="product.new_item === 'present'" class="label new-item">
          <p class="label__text">Nyhed</p>
        </div>
        <div
          v-else-if="product.members_discount === 'present'"
          class="label members-discount"
        >
          <p class="label__text">Medlemsrabat</p>
        </div>
        <div
          v-if="product.sold_out !== 'present' && product.luxus === 'present'"
          class="label luxus"
        >
          <p class="label__text">Luxus</p>
        </div>
        <div v-else-if="product.petlux === 'present'" class="label petlux">
          <p class="label__text">PETLUX</p>
        </div>
        <div
          v-else-if="product.sustainable === 'present'"
          class="label sustainable"
        >
          <p class="label__text">Bæredygtigt</p>
        </div>
      </div>
      <div class="ProductItem__Info ProductItem__Info--left">
        <div class="ProductItem__Vendor-Wishlist">
          <p class="ProductItem__Vendor font-size-10 font-weight-500">
            {{ product.vendor }}
          </p>
          <!-- Swym Wishlist Plus EPI Button-->
          <button
            data-with-epi="true"
            :class="`swym-button swym-add-to-wishlist-view-product product_${product.id}`"
            data-swaction="addToWishlist"
            :data-product-id="product.id_json"
            :data-variant-id="product.variant"
            :data-product-url="product.shop_url + product.wishlist_url"
          ></button>
          <!-- Swym Wishlist Plus EPI Button-->
        </div>
        <h2 class="ProductItem__Title font-size-12 font-weight-300">
          <a :href="product.url">{{ product.title }}</a>
        </h2>
        <div class="ProductItem__PriceList">
          <span class="ProductItem__Price Price font-size-12 font-weight-600"
            >{{ product.price }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductItem {
  max-width: 245px;
  width: 100%;
  .AspectRatio {
    padding-bottom: 120%;
  }
  .ProductItem__ImageWrapper {
    img:last-child {
      opacity: 0;
    }
    img:only-child {
      opacity: 1;
    }
    &:hover {
      img:first-child {
        opacity: 0;
      }
      img:last-child {
        opacity: 1;
      }
      img:only-child {
        opacity: 1;
      }
    }
  }
}
</style>
